/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponentHealthSummaryAndDetails } from './providerComponentHealthSummaryAndDetails';
import { ProviderComponentApplicationHealth } from './providerComponentApplicationHealth';


export interface ProviderComponentHealthInfo { 
    application?: ProviderComponentApplicationHealth;
    infrastructure?: { [key: string]: ProviderComponentHealthSummaryAndDetails; };
}

